import React, { useEffect, useState } from 'react';

import SimpleVideoPlayer from '../blogComponents/SimpleVideoPlayer';


function GuestVideoPlayer(props) {
  const { user, selectedVideo } = props;

  return (
    <SimpleVideoPlayer
      clip={selectedVideo}
      guestHomePage={true}
      guestVideoPlayer={true}
      homePage={true}
      isProgram={true}
      user={user}
    />
  );
}

export default GuestVideoPlayer;
